export function useProviderEvent() {
  const nuxtApp = useNuxtApp();
  return nuxtApp.$providerEvent;
}
